import { useState, useEffect } from "react";

export default function InstallBanner({ lang }: { lang: string }) {
  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [instructions, setInstructions] = useState("");
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (window.navigator as any).standalone === true;

    if (standalone) {
      setIsStandalone(true);
      return;
    }

    const ua = navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(ua);
    const isSafari = /safari/.test(ua) && !/chrome/.test(ua);
    const isFirefox = /firefox/.test(ua);
    const isChrome = /chrome/.test(ua) && !/edge/.test(ua);
    const isEdge = /edge|edg/.test(ua);
    const isAndroid = /android/.test(ua);

    const es = lang === "es";
    if (isIOS && isSafari) {
      setInstructions(es ? 'En Safari: toca el icono Compartir y luego Agregar a pantalla de inicio' : 'On Safari: tap the Share icon then Add to Home Screen');
    } else if (isAndroid && isChrome) {
      setInstructions(es ? 'En Chrome: toca el menu (3 puntos) y luego Agregar a pantalla de inicio' : 'On Chrome: tap the menu (3 dots) then Add to Home Screen');
    } else if (isFirefox) {
      setInstructions(es ? 'En Firefox: toca el menu y luego Instalar o Agregar a pantalla de inicio' : 'On Firefox: tap the menu then Install or Add to Home Screen');
    } else if (isEdge) {
      setInstructions(es ? 'En Edge: toca el menu (3 puntos) y luego Agregar a telefono' : 'On Edge: tap the menu (3 dots) then Add to phone');
    } else {
      setInstructions(es ? 'Abre el menu de tu navegador y selecciona Agregar a pantalla de inicio para instalar Legado como app.' : 'Open your browser menu and select Add to Home Screen to install the Legado app.');
    }

    const dismissed = localStorage.getItem("pwa-banner-dismissed");
    const dismissedTime = dismissed ? parseInt(dismissed) : 0;
    const sevenDays = 7 * 24 * 60 * 60 * 1000;

    if (!dismissed || Date.now() - dismissedTime > sevenDays) {
      setShowBanner(true);
    }
  }, []);

  const dismissBanner = () => {
    localStorage.setItem("pwa-banner-dismissed", Date.now().toString());
    setShowBanner(false);
  };

  if (isStandalone) return null;

  return (
    <>
      {showBanner && (
        <div style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          background: "#1A3C5E",
          color: "#fff",
          padding: "14px 16px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          zIndex: 9999,
          boxShadow: "0 -2px 12px rgba(0,0,0,0.3)"
        }}>
          <img src="/logo192.png" alt="Legado" style={{ width: 40, height: 40, borderRadius: 10, flexShrink: 0 }} />
          <div style={{ flex: 1 }}>
            <p style={{ fontWeight: 600, fontSize: 14, margin: "0 0 2px" }}>
              {lang === "es" ? "Instala Legado, Inc. como app" : "Install Legado, Inc. as an app"}
            </p>
            <p style={{ fontSize: 12, margin: 0, opacity: 0.85 }}>
              {instructions}
            </p>
          </div>
          <button onClick={dismissBanner} style={{
            background: "transparent",
            border: "none",
            color: "#fff",
            fontSize: 20,
            cursor: "pointer",
            padding: "4px 8px",
            flexShrink: 0
          }}>x</button>
        </div>
      )}

      {!showBanner && (
        <button
          onClick={() => setShowModal(true)}
          title="Instalar app"
          style={{
            position: "fixed",
            bottom: 20,
            right: 20,
            width: 48,
            height: 48,
            borderRadius: "50%",
            background: "#1A3C5E",
            border: "none",
            color: "#fff",
            fontSize: 22,
            cursor: "pointer",
            zIndex: 9999,
            boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
          +
        </button>
      )}

      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            zIndex: 10000,
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center"
          }}>
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: "20px 20px 0 0",
              padding: "24px 20px 32px",
              width: "100%",
              maxWidth: 480
            }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
              <img src="/logo192.png" alt="Legado" style={{ width: 48, height: 48, borderRadius: 12 }} />
              <div>
                <p style={{ fontWeight: 600, fontSize: 16, margin: 0 }}>Instalar Legado, Inc.</p>
                <p style={{ fontSize: 13, color: "#777", margin: 0 }}>legadoinc.org</p>
              </div>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  marginLeft: "auto",
                  background: "transparent",
                  border: "none",
                  fontSize: 20,
                  cursor: "pointer",
                  color: "#999"
                }}>x</button>
            </div>
            <div style={{
              background: "#f0f4f8",
              borderRadius: 12,
              padding: "14px 16px",
              marginBottom: 16
            }}>
              <p style={{ fontSize: 14, margin: 0, color: "#1A3C5E", lineHeight: 1.6 }}>
                {instructions}
              </p>
            </div>
            <p style={{ fontSize: 12, color: "#aaa", textAlign: "center", margin: 0 }}>
              {lang === "es" ? "Toca fuera para cerrar" : "Tap outside to close"}
            </p>
          </div>
        </div>
      )}
    </>
  );
}
